import { useEffect } from "react";
import { SiteHeader, SiteFooter } from "@/components/SiteChrome";
import { Hero, HowItWorks, QrDemo } from "@/components/landing/HeroSections";
import { ExampleGallery, Pricing, Products, Services } from "@/components/landing/OfferSections";
import { Faq, Contact } from "@/components/landing/InfoSections";

export default function Landing() {
  useEffect(() => {
    document.title = "Najin trenutek · Poročna galerija s QR kodo";
    if (window.location.hash) {
      const t = setTimeout(() => document.querySelector(window.location.hash)?.scrollIntoView({ behavior: "smooth" }), 500);
      return () => clearTimeout(t);
    }
  }, []);
  return (
    <div data-testid="landing-page">
      <SiteHeader />
      <Hero />
      <HowItWorks />
      <QrDemo />
      <ExampleGallery />
      <Pricing />
      <Products />
      <Services />
      <Faq />
      <Contact />
      <SiteFooter />
    </div>
  );
}
